import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registry',
  templateUrl: './registry.component.html',
  styleUrls: ['./registry.component.scss']
})
export class RegistryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  onClick(){
    window.open("https://www.myregistry.com/wedding-registry/Amy-Zhang-and-Sawyer-Harris-Morrisville-NC/2172900", "_blank");
  }

}
